import React, { PureComponent } from 'react';
import TASKBAR from './EXPLORE/TASKBAR.js';
import WINAPI from './WINAPI.js';
import CURSOR from './CURSOR.js';
import ICONS from './ICONS.js';
import './WIN.css';
import BSOD from './BSOD';
import DESKTOP from './EXPLORE/DESKTOP';

class SHUTDOWN_VEIL extends PureComponent {
  render() {
    return <div className="shutdown-veil">
    </div>;
  }
}

let numAnimationStages = 4;
let animationInterval = 500;

// a bit hacky, the WIN is the base component, it is also 
class WIN extends PureComponent {
  constructor() {
    super();

    this.api = new WINAPI(this);
    window.WINAPI = this.api;
    this.wndElements = [];

    this.hwnds = [];
    this.wnds = {};
    this.overlayElement = document.createElement("div");

    this.state = {
      foregroundHwnd: -1,
      showBsod: false,
      showShutdownVeil: false,
      animationStage: 0
    };
  }

  overlayRef(overlay) {
    if (overlay) {
      overlay.appendChild(this.overlayElement);
    } else {
      this.overlayElement.parentElement.removeChild(this.overlayElement);
    }
  }

  playAnimation() {
    window.WINAPI.CreateProcess("C:\\WINDOWS\\iexplore.exe");
    //window.WINAPI.CreateProcess("C:\\WINDOWS\\Explorer.exe");
    //window.WINAPI.CreateProcess("C:\\WINDOWS\\Notepad.exe", "C:\\Scandisk.log");

    setTimeout(this.advanceAnimation.bind(this, 4), animationInterval);
  }

  advanceAnimation(direction) {
    let newStage = this.state.animationStage + direction;
    this.setState({ animationStage: newStage });

    if (newStage < numAnimationStages && newStage > 0) {
      setTimeout(this.advanceAnimation.bind(this, direction), animationInterval);
    } else {
      if (newStage == 0) {
        setTimeout(this.props.shutoff, 800);
      }
    }
  }

  componentDidMount() {
    this.playAnimation();
  }

  addWnd(hwnd, wndElement) {
    this.wndElements[hwnd] = wndElement;
    this.forceUpdate();
  }

  wndRef(hwnd, wnd) {
    if (this.wnds[hwnd] === undefined) {
      this.hwnds.push(hwnd);
      this.wnds[hwnd] = wnd;
      this.forceUpdate();
    }
  }

  removeWnd(hwnd) {
    this.hwnds.splice(this.hwnds.indexOf(hwnd), 1);
    this.wnds[hwnd] = null; // Terminated
    delete this.wndElements[hwnd];
    this.forceUpdate();
  }

  rootRef(rootElm) {
    if (rootElm) {
      this.rootElm = rootElm;
      this.rootElmListener = (event) => {
        this.api.lastMousePosition = [event.pageX, event.pageY];
      };
      this.rootElm.addEventListener("mousemove", this.rootElmListener);
    } else {
      this.rootElm.removeEventListener("mousemove", this.rootElmListener);
    }
  }

  globalMouseDown(event) {
    window.WINAPI.TriggerEvent('dismiss');
    return false;
  }

  shutoff() {
    setTimeout(this.advanceAnimation.bind(this, -1), animationInterval);
  }

  render() {

    // todo - make sure it only happens once/twice in initial render

    var elems = [];
    for (const wndElement of Object.values(this.wndElements)) {
      elems.push(wndElement);
    }

    var animClasses = ["win"];
    for (var i = this.state.animationStage; i < numAnimationStages; i++) {
      animClasses.push("win-anim-" + i);
    }

    return (
      <div className={animClasses.join(" ")} ref={this.rootRef.bind(this)} onMouseDown={this.globalMouseDown.bind(this)}>
        <DESKTOP />
        <div className="win-hwnds">{elems}</div>
        <TASKBAR hwnds={this.hwnds.slice() /*slice to force update*/} foregroundHwnd={this.state.foregroundHwnd}/>
        <div ref={this.overlayRef.bind(this)} className="win-overlay"></div>
        {this.state.showShutdownVeil ? <SHUTDOWN_VEIL /> : null}
        {/*<CURSOR icon={ICONS.CUR_STD} />*/}
        {this.state.showBsod ? <BSOD dismiss={() => this.setState({showBsod: false})} /> : null}
      </div>
    );
  }
}

export default WIN;



// WEBPACK FOOTER //
// ./src/walleris/WIN.js